export default "__VITE_ASSET__9cce1215__"